import React from "react";

import GridViewIcon from '@mui/icons-material/GridView';
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InventoryIcon from '@mui/icons-material/Inventory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import LoopRoundedIcon from '@mui/icons-material/LoopRounded';
import ShuffleRoundedIcon from '@mui/icons-material/ShuffleRounded';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
import BuildCircleSharpIcon from '@mui/icons-material/BuildCircleSharp';
import InboxIcon from '@mui/icons-material/Inbox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HistoryIcon from '@mui/icons-material/History';
import SendIcon from '@mui/icons-material/Send';
import { ReactComponent as EyeClosedIcon }  from "../../../asset/images/closed-eye.svg";
import { ReactComponent as EyeOpenedIcon }  from "../../../asset/images/open-eye.svg";
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import PersonOffRoundedIcon from '@mui/icons-material/PersonOffRounded';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import LockIcon from "@mui/icons-material/Lock";
import PaymentIcon from "@mui/icons-material/Payment";
import KeyIcon from "@mui/icons-material/Key";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import AddPhotoAlternateOutlined from '@mui/icons-material/PersonOutlined';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import CloudUploadOutlined from '@mui/icons-material/PhotoCameraOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import RefreshIcon from '@mui/icons-material/Refresh';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { PTTooltip } from ".";

export const icons = {
  print: (props) => <PrintIcon sx={{ color: "#242B59" }} {...props} />,
  logout: (props) => <LogoutIcon sx={{ color: "#242B59" }} {...props} />,
  notification: (props) => <NotificationsIcon sx={{ color: "#242B59" }} {...props} />,
  grid: (props) => <GridViewIcon sx={{ color: "#242B59" }} {...props} />,
  search: (props) => <SearchIcon sx={{ color: "#242B59" }} {...props} />,
  arrowDown: (props) => <ArrowDropDownIcon sx={{ color: "#242B59" }} {...props} />,
  arrowUp: (props) => <ArrowDropUpIcon sx={{ color: "#242B59" }} {...props} />,
  keyboardArrowDown: (props) => <KeyboardArrowDownIcon sx={{ color: "#242B59" }} {...props} />,
  keyboardArrowUp: (props) => <KeyboardArrowUpIcon sx={{ color: "#242B59" }} {...props} />,
  assignmentInd: (props) => <AssignmentIndIcon sx={{ color: "#242B59" }} {...props} />,
  vpnKey: (props) => <VpnKeyIcon sx={{ color: "#242B59" }} {...props} />,
  help: (props) => <HelpOutlineIcon sx={{ color: "#242B59" }} {...props} />,
  inventory: (props) => <InventoryIcon sx={{ color: "#242B59" }} {...props} />,
  download: (props) => <ArrowDownwardIcon sx={{ color: "#242B59" }} {...props} />,
  loopRounded: (props) => <LoopRoundedIcon sx={{ color: "#242B59" }} {...props} />,
  shuffleRounded: (props) => <ShuffleRoundedIcon sx={{ color: "#242B59" }} {...props} />,
  hourglassEmpty: (props) => <HourglassEmptyIcon sx={{ color: "#242B59" }} {...props} />,
  playlistAddCheckCircle: (props) => <PlaylistAddCheckCircleIcon sx={{ color: "#242B59" }} {...props} />,
  buildCircleSharp: (props) => <BuildCircleSharpIcon sx={{ color: "#242B59" }} {...props} />,
  inbox: (props) => <InboxIcon sx={{ color: "#242B59" }} {...props} />,
  arrowForward: (props) => <ArrowForwardIcon sx={{ color: "#242B59" }} {...props} />,
  done: (props) => <DoneIcon sx={{ color: "#242B59" }} {...props} />,
  close: (props) => <CloseIcon sx={{ color: "#242B59" }} {...props} />,
  view: (props) => <EyeOpenedIcon sx={{ color: "#242B59" }} {...props} />,
  viewClosed: (props) => <EyeClosedIcon sx={{ color: "#242B59" }} {...props} />,
  edit: (props) => <ModeEditRoundedIcon sx={{ color: "#242B59" }} {...props} />,
  usersManagement: (props) => <PeopleAltRoundedIcon sx={{ color: "#242B59" }} {...props} />,
  delete: (props) => <DeleteRoundedIcon sx={{ color: "#242B59" }} {...props} />,
  desactivate: (props) => <PersonOffRoundedIcon sx={{ color: "#242B59" }} {...props} />,
  accountSettings: (props) => <ManageAccountsIcon sx={{ color: "#242B59" }} {...props} />,
  arrowForward: (props) => <ArrowForwardIosIcon sx={{ color: "#242B59" }} {...props} />,
  arrowBack: (props) => <ArrowBackIosIcon sx={{ color: "#242B59" }} {...props} />,
  lock: (props) => <LockIcon sx={{ color: "#242B59" }} {...props} />,
  payment: (props) => <PaymentIcon sx={{ color: "#242B59" }} {...props} />,
  keyIcon: (props) => <KeyIcon sx={{ color: "#242B59" }} {...props} />,
  creditCard: (props) => <CreditCardIcon sx={{ color: "#242B59" }} {...props} />,
  danger: (props) => <ErrorOutlineIcon sx={{ color: "#F44336" }} {...props} />,
  history: (props) => <HistoryIcon sx={{ color: "#242B59" }} {...props} />,
  send: (props) => <SendIcon sx={{ color: "#242B59" }} {...props} />,
  person: (props) => <PersonRoundedIcon sx={{ color: "#242B59" }} {...props} />,
  addPhoto: (props) => <AddPhotoAlternateOutlined sx={{ color: "#242B59" }} {...props} />,
  upload: (props) => <CloudUploadOutlined sx={{ color: "#242B59" }} {...props} />,
  photo: (props) => <PhotoCameraOutlinedIcon sx={{ color: "#242B59" }} {...props} />,
  info: (props) => <InfoOutlinedIcon sx={{ color: "#242B59" }} {...props} />,
  checkCircle: (props) => <CheckCircleOutlinedIcon sx={{ color: "#242B59" }} {...props} />,
  cancel: (props) => <CancelOutlinedIcon sx={{ color: "#242B59" }} {...props} />,
  supervisorAccount: (props) => <SupervisorAccountIcon sx={{ color: "#242B59" }} {...props} />,
  airlineStops: (props) => <AirlineStopsIcon sx={{ color: "#242B59" }} {...props} />,
  refresh: (props) => <RefreshIcon sx={{ color: "#242B59" }} {...props} />,
  done_all: (props) => <DoneAllIcon sx={{ color: "#242B59" }} {...props} />,
  more_vert: (props) => <MoreVertIcon sx={{ color: "#242B59" }} {...props} />,
  open_in_new: (props) => <OpenInNewIcon sx={{ color: "#242B59" }} {...props} />,
};

export const PTIcon = (props) => {
  const { icon, tooltip, color, ...otherprops } = props;
  if (color) {
    otherprops.sx = { ...otherprops.sx, color: color };
  }
  if (!!tooltip) {
    return <PTTooltip title={tooltip}>{icons[icon](otherprops)}</PTTooltip>;
  }
  return icons?.[icon]?.(otherprops) || null;
};

export default PTIcon;
